import { Attribute, Element, ParseSourceSpan, Text } from '@angular/compiler';
import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';

const tagName = 'section';

const noSpan = ({} as ParseSourceSpan);
const createElement = (name: string) => {
  return new Element(name, [], [], noSpan, noSpan, noSpan);
};

const addAttribute = (node: Element, name: string, value: string) => {
  const attr = new Attribute(name, value, noSpan, noSpan, noSpan, undefined, undefined);
  node.attrs.push(attr);
};

register('wm-partial', (): IBuildTaskDef => {
    return {
      template: (node: Element)  => {
        const conditionalNode = createElement('ng-container');
        // addAttribute(conditionalNode, '*ngIf', 'compileContent');
        conditionalNode.children = conditionalNode.children.concat(node.children);
        
        let isPartialPage = node?.attrs?.find(attrObj => attrObj.name === "widgettype" && attrObj.value === "wm-partial");
        // @ts-ignore
        isPartialPage && conditionalNode.children.push(new Text('{{onPageContentReady()}}', null, undefined, undefined));
        node.children.length = 0;
        node.children.push(conditionalNode);
      },
      pre: attrs => `<${tagName} wmPartial data-role="partial" ${getAttrMarkup(attrs)} wmsTransclude>`,
      post: () => `</${tagName}>`
    };
});

export default () => {};
